// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IStorageUsageInfo {
	statusTimestamp: string | undefined;

	free: number | undefined;

	optOmnisight: number | undefined;

	dvr: number | undefined;

	logs: number | undefined;

	total: number | undefined;

	earliestDVRStart: string | undefined;

	dvrRangeEnd: string | undefined;

	$type?: string | undefined;
}
export class StorageUsageInfo {
	constructor(data?: IStorageUsageInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.statusTimestamp) { this.statusTimestamp = new Date(data.statusTimestamp); }
		if (data.earliestDVRStart) { this.earliestDVRStart = new Date(data.earliestDVRStart); }
		if (data.dvrRangeEnd) { this.dvrRangeEnd = new Date(data.dvrRangeEnd); }
	}

	statusTimestamp: Date | undefined = new Date();

	free: number | undefined;

	optOmnisight: number | undefined;

	dvr: number | undefined;

	logs: number | undefined;

	total: number | undefined;

	earliestDVRStart: Date | undefined = new Date();

	dvrRangeEnd: Date | undefined;

	static $type: string = "Shared.Models.View.Hardware.StorageUsageInfo, ";
	$type?: string | undefined = StorageUsageInfo.$type;
}

